export default __webpack_public_path__ + "static/img-team-3-04639d3e4dbf72f0bc0391f85b522de3.png";